// extracted by mini-css-extract-plugin
module.exports = {"base":"BrandMark-base-acaff6f43cf161e97c9a8eb34f77fddf","md":"BrandMark-md-13c56d73ea8fd51a353a566e0f7583fb","lg":"BrandMark-lg-0b5cceb1e9bd5f3bad5f13d18e9b3dbd"};